export const COLORS = {
    primary: "#0072FF",
    secondary: "#f1c40f"
}